import React, { useState, useEffect } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { Form } from 'react-bootstrap';
import { getIn, setIn } from 'formik';
import { getPlaceDetailsByTextSearch, countryNames} from '../../const';
import _ from 'lodash';
import { GoogleApiWrapper } from 'google-maps-react'

const { Control, Group, Label } = Form;

function LocationAutocomplete({
  field = {},
  form: { touched = {}, errors = {}, setFieldValue, setTouched = () => {} } = {},
  displayKey = '',
  placeholder = 'Type location...',
  controlId = '',
  label = '',
  autoFocus = false,
  needCityState = false,
  needCityCountry = false,
  needCityNameOnly = false,
  countriesList = false,
  searchOptions = {},
  needFullAddress = false,
  needBounds = false,
}) {
  const [query, setQuery] = useState(
    typeof field.value === 'string'
      ? field.value
      : (displayKey && field.value?.[displayKey]) || field.value?.city || ''
  );

  useEffect(() => {
    const val = field.value;
    if (typeof val === 'string') {
      setQuery(val);
    } else if (val && typeof val === 'object') {
      if (displayKey && val[displayKey]) {
        setQuery(val[displayKey]);
      } else if (val.city) {
        setQuery(val.city);
      } else {
        setQuery('');
      }
    } else {
      setQuery('');
    }
  }, [field.value, displayKey]);

  const showError =
    field.name &&
    getIn(touched, field.name) &&
    getIn(errors, field.name);

  const onChange = value => {
    setQuery(value);
    setFieldValue(field.name, value);
  };

  const findItemAddressComponent = (address_components, level) => {
    return address_components.find(item => item.types.includes(level))
  }

  const findCityName = (address_components, location) => {
    let seachOne = address_components.find(
      item =>
        item.types.includes('locality') && item.types.includes('political')
    )
    if (!seachOne) {
      let searchTwo = address_components.find(item =>
        item.types.includes('postal_town')
      )
      if (!searchTwo) {
        if (location === 'Ibiza, Spain') {
          let searchThree = address_components.find(item =>
            item.types.includes('establishment')
          )
          return searchThree
        }

        return address_components.find(item => item.types.includes('political'))
      } else {
        return searchTwo
      }
    } else {
      return seachOne
    }
  }

  const checkIsTrain = types => {
    let isTrain = false
    var typesTrain = [
      'subway_station',
      'train_station',
      'transit_station',
      'railway',
    ]
    _.each(typesTrain, train => {
      let index = _.indexOf(types, train)
      if (!isTrain && index !== -1) {
        isTrain = true
      }
    })
    return isTrain
  }

  const onSelect = async (location) => {

    let placeId,
        city,
        state,
        country,
        geo,
        geoJson = null,
        postCode = null,
        geoBounds = null,
        isAirportType = false,
        isTrain = false,
        isStadium = false,
        isPort = false,
        isHotel = false,
        isMetro = false

    let results = []
    results = await getPlaceDetailsByTextSearch(location)
    if (results && results.data && results.data.info) {
        const place = results.data.info.result
        const { geometry, address_components, place_id } = place
        placeId = place_id
        geo = geometry
        postCode = (
        findItemAddressComponent(address_components, 'postal_code') || {}
        ).short_name

        country = (
        findItemAddressComponent(address_components, 'country') || {}
        ).short_name

        state = (
        findItemAddressComponent(
            address_components,
            'administrative_area_level_1'
        ) ||
        findItemAddressComponent(
            address_components,
            'administrative_area_level_2'
        ) ||
        {}
        ).short_name

        city =
        (findCityName(address_components, location) || {}).long_name ===
            'Roma' && country === 'IT'
            ? 'Rome'
            : (findCityName(address_components, location) || {}).long_name ===
                'Iraklio' && country === 'GR'
            ? 'Heraklion'
            : (findCityName(address_components, location) || {}).long_name ||
            address_components[0].long_name

        isAirportType =
        location.toLowerCase().search('airport') !== -1 ||
        (location.toLowerCase().search('terminal') !== -1 &&
            location.toLowerCase().search('cruise terminal') === -1) ||
        location.toLowerCase().search('aeropuerto') !== -1 ||
        location.toLowerCase().search('aeroporto') !== -1 ||
        location.toLowerCase().search('aéroport') !== -1 ||
        location.toLowerCase().search('mxp t1') !== -1 ||
        location.search('LHR') !== -1 ||
        location.search('(ICN)') !== -1 ||
        location.search('4561 West Empire Avenue, Burbank') !== -1
            ? !location.toLowerCase().includes('ihg hotel')
            ? true
            : false
            : _.indexOf(place.types, 'airport') !== -1 ||
            _.indexOf(place.types, 'aeroway') !== -1
            ? true
            : false

        isTrain =
        location.toLowerCase().search('airport') !== -1
            ? false
            : location.toLowerCase().search('train station') !== -1
            ? true
            : checkIsTrain(place.types)

        isStadium =
        location.search('Stadium') !== -1 ||
        location.search('Arena') !== -1 ||
        location.search('Stade') !== -1 ||
        _.indexOf(place.types, 'stadium') !== -1

        isPort = place.name
        ? place.name.match(new RegExp('\\b' + 'Port' + '\\b')) !== null ||
            place.name.match(
            new RegExp('\\b' + 'Cruise Terminal' + '\\b')
            ) !== null
        : false

        isHotel =
        location.search('Hotel') !== -1 ||
        location.search('Hôtel') !== -1 ||
        location.search('Resort') !== -1 ||
        _.indexOf(place.types, 'lodging') !== -1
            ? true
            : false

        if (isTrain) {
        isMetro =
            location.toLowerCase().search('metro station') !== -1
            ? true
            : false
        }
    }

    let item = {
        city: city || location,
        placeId: placeId,
        state: state || '',
        country: country || '',
        ...(geoJson ? geoJson : null),
        ...(geo
        ? typeof geo.location === 'function'
            ? geo.location.toJSON()
            : geo.location
        : null),
        ...(postCode ? { postCode: postCode } : {}),
        ...(needCityNameOnly ? { cityName: city } : {}),
        locationType: isAirportType
        ? 'isAirport'
        : isMetro
        ? 'isMetro'
        : isTrain
        ? 'isTrain'
        : isStadium
        ? 'isStadium'
        : isPort
        ? 'isPort'
        : isHotel
        ? 'isHotel'
        : 'other',
    }
    if (geo && geo.bounds && needBounds) {
        item.bounds =
        typeof geo.bounds === 'function'
            ? geo.bounds.toJSON()
            : {
                east: geo.bounds.northeast.lng,
                north: geo.bounds.northeast.lat,
                south: geo.bounds.southwest.lat,
                west: geo.bounds.southwest.lng,
            }
    } else if (geo && geo.viewport && needBounds) {
        item.bounds =
        typeof geo.viewport === 'function'
            ? geo.viewport.toJSON()
            : {
                east: geo.viewport.northeast.lng,
                north: geo.viewport.northeast.lat,
                south: geo.viewport.southwest.lat,
                west: geo.viewport.southwest.lng,
            }
    } else if (geoBounds && geoBounds.bounds && needBounds) {
        item.bounds = geoBounds.bounds
    }
    if (needFullAddress) {
        if (postCode) {
        let addressWithPostCode =
            country === 'GB'
            ? location.replace(
                city + ', UK',
                city + ', ' + postCode + ', UK'
                )
            : country === 'CA'
            ? location.replace(
                state + ', Canada',
                state + ', ' + postCode + ', Canada'
                )
            : country === 'NZ'
            ? location.replace(
                city + ', New Zealand',
                city + ', ' + postCode + ', New Zealand'
                )
            : country === 'US'
            ? location.replace(', USA', ', ' + postCode + ', USA')
            : location.replace(
                city + ', ' + country,
                city + ', ' + postCode + ', ' + country
                )
        item.fullAddress = addressWithPostCode
        } else {
        item.fullAddress = location
        }
    }
    if (needCityState) {
        if (placeId === 'ChIJBQ07-vf7mkcRKxqfnGm-7KY') {
        item.cityState = 'Bodensee, Germany'
        } else if (placeId === 'ChIJB2SfQXxvjEcRqqCei3C8hlg') {
        item.cityState = 'Vésenaz, Switzerland'
        } else {
        item.cityState = city + ', ' + (state ? state : country)
        }
    }
    if (needCityCountry) {
        const countryCode = country
        const countryData = countryNames.find(c => c.code === countryCode)
        const countryFullName = countryData ? countryData.name : null

        if (country === 'US' || country === 'CA') {
        item.cityCountry =
            city +
            ', ' +
            state +
            ', ' +
            (countryFullName ? countryFullName : countryCode)
        } else {
        item.cityCountry =
            city + ', ' + (countryFullName ? countryFullName : countryCode)
        }
    }
    if (city === 'Jerusalem' && !country) {
        item.country = 'IL'
    }
    setFieldValue(field.name, item);
    setQuery((displayKey && item[displayKey]) || item.city || location);
  };

  const handleBlur = () => {
    const t = setIn({ ...touched }, field.name, true);
    setTouched(t);
  };

  var sortedArray, arrayOfValues;

  const airportSearch = unSortedArray => {
    if (unSortedArray.length !== 0) {
      sortedArray = []
      arrayOfValues = []

      _.each(unSortedArray, item => {
        if (item['types'].includes('country')) {
          arrayOfValues.push({ priority: 1, icon: '', ...item })
        }
      })
      sortedArray = _.sortBy(arrayOfValues, ['priority'])
    }
    return sortedArray
  }

  const sortingAlgorithm = unSortedArray => {

    if (unSortedArray.length !== 0) {
      sortedArray = []
      arrayOfValues = []

      _.each(unSortedArray, (item, index) => {
        if (item['types'] && item['types'].includes('airport')) {
          arrayOfValues.push({ priority: 1, icon: 'Airport', ...item })
        } else if (
          item['types'] &&
          item['types'].includes('light_rail_station')
        ) {
          arrayOfValues.push({ priority: 2, icon: 'Train_station', ...item })
        } else if (item['types'] && item['types'].includes('train_station')) {
          arrayOfValues.push({ priority: 3, icon: 'Train_station', ...item })
        } else if (
          item['description'] &&
          item['description'].includes('Train Station')
        ) {
          arrayOfValues.push({ priority: 3, icon: 'Train_station', ...item })
        } else if (
          item['description'] &&
          item['description'].includes('Metro Station')
        ) {
          arrayOfValues.push({ priority: 3, icon: 'Train_station', ...item })
        } else if (item['types'] && item['types'].includes('transit_station')) {
          arrayOfValues.push({ priority: 4, icon: 'Port', ...item })
        } else if (item['types'] && item['types'].includes('lodging')) {
          arrayOfValues.push({ priority: 5, icon: 'Hotel', ...item })
        } else if (item['types'] && item['types'].includes('restaurant')) {
          arrayOfValues.push({ priority: 6, icon: 'Restaurant', ...item })
        } else if (item['types'] && item['types'].includes('bar')) {
          arrayOfValues.push({ priority: 7, icon: 'Bar_and_Club', ...item })
        } else if (item['types'] && item['types'].includes('club')) {
          arrayOfValues.push({ priority: 8, icon: 'Bar_and_Club', ...item })
        } else {
          arrayOfValues.push({ priority: 9, icon: 'Location', ...item })
        }
      })
      sortedArray = _.sortBy(arrayOfValues, ['priority'])
    }
    if (sortedArray && sortedArray.length > 0) {
    //   setShowLoader(false)
    }
    return sortedArray
  }

  return (
    <PlacesAutocomplete
      value={query}
      onChange={onChange}
      onSelect={onSelect}
      searchOptions={searchOptions}
      debounce={300}
    >
      {({ getInputProps, suggestions: rawSuggestions, getSuggestionItemProps, loading }) => {
        const suggestions = (countriesList ? airportSearch(rawSuggestions) : sortingAlgorithm(rawSuggestions)) || [];
  
        return (
          <>
            <Group controlId={controlId}>
              {label && <Label>{label}</Label>}
              <Control
                {...getInputProps({
                  placeholder,
                  onBlur: handleBlur,
                  className: `location-autocomplete-control ${loading ? 'flightTracking-loader-register' : ''}`, 
                  autoFocus,
                })}
                isInvalid={!!showError}
              />
              {showError && (
                <Control.Feedback type="invalid">
                  {getIn(errors, field.name)}
                </Control.Feedback>
              )}
            </Group>
    
            {!!suggestions.length && (
              <div className="location-autocomplete-result">
                {suggestions.map(item => {
                  const className = item.active
                    ? 'location-autocomplete-item active'
                    : 'location-autocomplete-item';
                  return (
                    <div
                      key={item.placeId}
                      {...getSuggestionItemProps(item, { className })}
                    >
                      <span className="d-flex align-self-start">
                        <div>
                          <img
                            className="pr-2"
                            style={{ maxWidth: '30px' }}
                            src={`/images/mapIcons/Icon_${item.icon}.png`}
                            alt=""
                          />
                        </div>
                        <div style={{ paddingTop: item.icon === 'Hotel' ? 4.5 : 5 }}>
                          {item.description}
                        </div>
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        );
      }}
    </PlacesAutocomplete>
  );
  
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyD_7NG2i0XhBMScTh30xxoJouQe1lnvb68',
    language: 'en',
})(LocationAutocomplete);